import * as THREE from 'three'
import imagesLoaded from 'imagesloaded'
import gsap from 'gsap'
import 'swipe-touch-events';

//import gsap from 'gsap/gsap';

let loader;
var clickSlider;

class ClapatWebGL {
    constructor(opts) {
        this.scene = new THREE.Scene();
        this.vertex = `varying vec2 vUv;void main() {vUv = uv;gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );}`;
        this.material = opts.material;
        this.fragment = opts.fragment;
        this.uniforms = opts.uniforms;
        this.renderer = new THREE.WebGLRenderer();
        this.width = window.innerWidth;
        this.height = window.innerHeight;
        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(this.width, this.height);
        //this.renderer.setClearColor(0xeeeeee, 1);
        this.renderer.setClearColor(0x23272A, 1.0);

        this.container = document.getElementById("canvas-slider");
        this.images = Array.from(document.querySelectorAll('.slide-img'));;
        this.width = this.container.offsetWidth;
        this.height = this.container.offsetHeight;
        this.container.appendChild(this.renderer.domElement);

        this.camera = new THREE.PerspectiveCamera(
            70,
            window.innerWidth / window.innerHeight,
            0.001,
            1000
        );

        this.camera.position.set(0, 0, 2);

        this.current = 0;
        this.textures = [];

        this.isRunning = false;
        this.paused = true;
        this.initiate(() => {
            //console.log(this.textures);
            this.setupResize();
            this.addObjects();
            this.resize();
            this.play();
        })

    }

    initiate(cb) {

        const promises = [];
        let that = this;
        this.images.forEach((img, i) => {
            let promise = new Promise(resolve => {

                that.textures[i] = new THREE.TextureLoader().load(img.src, resolve);
            });
            promises.push(promise);
        })

        Promise.all(promises).then(() => {
            cb();
        });
    }

    setupResize() {

        window.addEventListener("resize", this.resize.bind(this));
    }

    resize() {

        this.width = this.container.offsetWidth;
        this.height = this.container.offsetHeight;
        this.renderer.setSize(this.width, this.height);
        this.camera.aspect = this.width / this.height;

        // image cover
        this.imageAspect = this.textures[0].image.height / this.textures[0].image.width;
        let a1;
        let a2;
        if (this.height / this.width > this.imageAspect) {
            a1 = (this.width / this.height) * this.imageAspect;
            a2 = 1;
        } else {
            a1 = 1;
            a2 = (this.height / this.width) / this.imageAspect;
        }

        this.material.uniforms.resolution.value.x = this.width;
        this.material.uniforms.resolution.value.y = this.height;
        this.material.uniforms.resolution.value.z = a1;
        this.material.uniforms.resolution.value.w = a2;

        const dist = this.camera.position.z;
        const height = 1;
        this.camera.fov = 2 * (180 / Math.PI) * Math.atan(height / (2 * dist));

        this.plane.scale.x = this.camera.aspect;
        this.plane.scale.y = 1;

        this.camera.updateProjectionMatrix();

    }

    addObjects() {

        let dispImg = new THREE.TextureLoader().load(jQuery('#showcase-slider-webgl-holder').attr('data-pattern-img'));
        dispImg.wrapS = dispImg.wrapT = THREE.RepeatWrapping;

        this.material = new THREE.ShaderMaterial({
            uniforms: {
                effectFactor: {
                    type: "f",
                    value: 0.15
                },
                dispFactor: {
                    type: "f",
                    value: 0.0
                },
                currentImage: {
                    type: "t",
                    value: this.textures[0]
                },
                nextImage: {
                    type: "t",
                    value: this.textures[1]
                },
                disp: {
                    type: "t",
                    value: dispImg
                },
                resolution: {
                    type: "v4",
                    value: new THREE.Vector4()
                },
            },
            vertexShader: this.vertex,
            fragmentShader: this.fragment,
            transparent: true,
            opacity: 1.0
        });

        this.geometry = new THREE.PlaneGeometry(1, 1, 2, 2);

        this.plane = new THREE.Mesh(this.geometry, this.material);
        this.scene.add(this.plane);
    }

    stop() {
        this.paused = true;
    }

    play() {
        this.paused = false;
        this.render();
    }

    render() {

        if (this.paused) return;

        requestAnimationFrame(this.render.bind(this));
        this.renderer.render(this.scene, this.camera);
    }
}

(function( $ ) {
    if( $('#showcase-slider-webgl-holder').length > 0 ){

        var vertex = 'varying vec2 vUv; void main() {  vUv = uv;  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );	}';
        var fragment = `
            varying vec2 vUv;

            uniform sampler2D currentImage;
            uniform sampler2D nextImage;
            uniform sampler2D disp;
            uniform float dispFactor;
            uniform float effectFactor;
            uniform vec4 resolution;

            void main() {

                vec2 uv = (vUv - vec2(0.5))*resolution.zw + vec2(0.5);

                vec4 disp = texture2D(disp, uv);
                vec2 distortedPosition = vec2(uv.x + dispFactor * (disp.r*effectFactor), uv.y);
                vec2 distortedPosition2 = vec2(uv.x - (1.0 - dispFactor) * (disp.r*effectFactor), uv.y);
                vec4 _currentImage = texture2D(currentImage, distortedPosition);
                vec4 _nextImage = texture2D(nextImage, distortedPosition2);
                vec4 finalTexture = mix(_currentImage, _nextImage, dispFactor);

                gl_FragColor = finalTexture; }

            `;

        var gl_canvas = new ClapatWebGL({
                vertex: vertex,
                fragment: fragment,
        });
        
        if( $('#slider-webgl').length > 0 ){
            
            let above = document.getElementsByClassName('above')[0]
            above.addEventListener('swiperight', function(){                
                document.getElementById("slider-prev-arrow").click()
            });
            above.addEventListener('swipeleft', function(){
                document.getElementById("slider-next-arrow").click()
            });        
        
            var addEvents = function(){

                //var triggerSlide = Array.from(document.getElementById('trigger-slides').querySelectorAll('.slide-wrap'));
                let triggerSlide = document.getElementById('pagination').querySelectorAll('button');
                let pagButtons = Array.from(document.getElementById('pagination').querySelectorAll('button'));
                let pagButtonsLength = pagButtons.length - 1;
                let pagNav = Array.from(document.getElementById('slide-next-prev').querySelectorAll('a'));

                let waitTime = 5500;
                gl_canvas.isRunning = false;

                triggerSlide.forEach( (el) => {

                    el.addEventListener('click', function() {

                            if( !gl_canvas.isRunning ) {

                                gl_canvas.isRunning = true;

                                document.getElementById('pagination').querySelectorAll('.active')[0].className = '';
                                this.className = 'active';

                                var slideId = parseInt( this.dataset.slide, 10 );

                                gl_canvas.material.uniforms.nextImage.value = gl_canvas.textures[slideId];
                                gl_canvas.material.uniforms.nextImage.needsUpdate = true;

                                gsap.to( gl_canvas.material.uniforms.dispFactor, {
                                    duration: 0.9,
                                    value: 1,
                                    ease: 'Sine.easeInOut',
                                    onComplete: function () {
                                        gl_canvas.material.uniforms.currentImage.value = gl_canvas.textures[slideId];
                                        gl_canvas.material.uniforms.currentImage.needsUpdate = true;
                                        gl_canvas.material.uniforms.dispFactor.value = 0.0;
                                        gl_canvas.isRunning = false;
                                    }
                                });

                                let slideCurrentEl = document.getElementById('slide-current');
                                let slideTitleEl = document.getElementById('slide-title');
                                let slideCategoryEl = document.getElementById('slide-category');
                                let slideLinkEl = document.getElementById('slide-link');
                                let nextSlideTitle = document.querySelectorAll(`[data-slide-title="${slideId}"]`)[0].innerHTML;
                                let nextSlideCategory = document.querySelectorAll(`[data-slide-category="${slideId}"]`)[0].innerHTML;
                                let nextSlideLink = document.querySelectorAll(`[data-slide-link="${slideId}"]`)[0].innerHTML;
            
                                gsap.fromTo(slideCategoryEl, 0.5, {
                                    autoAlpha: 1,
                                    filter: 'blur(0px)',
                                    y: 0,
                                    x: 0,
                                }, {
                                    autoAlpha: 0,
                                    filter: 'blur(10px)',
                                    y: 20,
                                    x: 350,
                                    ease: 'Expo.easeIn',
                                    onComplete: function () {
                                        slideCategoryEl.innerHTML = nextSlideCategory;
            
                                        gsap.to(slideCategoryEl, 1, {
                                            autoAlpha: 1,
                                            filter: 'blur(0px)',
                                            y: 0,
                                            x: 0,
                                            delay: 0.1,
                                        })
                                    }
                                });
            
                                gsap.fromTo(slideTitleEl, 0.5, {
                                    autoAlpha: 1,
                                    filter: 'blur(0px)',
                                    y: 0,
                                    x: 0,
                                }, {
                                    autoAlpha: 0,
                                    filter: 'blur(10px)',
                                    y: 20,
                                    x: 350,
                                    ease: 'Expo.easeIn',
                                    onComplete: function () {
                                        slideTitleEl.innerHTML = nextSlideTitle;
            
                                        gsap.to(slideTitleEl, 0.5, {
                                            autoAlpha: 1,
                                            filter: 'blur(0px)',
                                            y: 0,
                                            x: 0,
                                            delay: 0.75,
                                        })
                                    }
                                });
            
                                gsap.fromTo( slideLinkEl, 0.5, {
                                        autoAlpha: 1,
                                        filter: 'blur(0px)',
                                        y: 0
                                }, {
                                    autoAlpha: 0,
                                    filter: 'blur(10px)',
                                    y: 20,
                                    x: 350,
                                    ease: 'Expo.easeIn',
                                    onComplete: function () {
                                        slideLinkEl.innerHTML = nextSlideLink;
            
                                        gsap.to( slideLinkEl, 0.5, {
                                            autoAlpha: 1,
                                            filter: 'blur(0px)',
                                            y: 0,
                                            x: 0,
                                            delay: 1.55,
                                        })
                                    }
                                });

                                gsap.fromTo( slideCurrentEl, 0.5, {
                                        autoAlpha: 1,
                                        filter: 'blur(0px)',
                                        y: 0.5,
                                }, {
                                    autoAlpha: 0,
                                    filter: 'blur(10px)',
                                    y: 20,
                                    ease: 'Expo.easeIn',
                                    onComplete: function () {
                                        slideCurrentEl.innerHTML = slideId + 1;
            
                                        gsap.to( slideCurrentEl, 0.5, {
                                            autoAlpha: 1,
                                            filter: 'blur(0px)',
                                            y: -1,
                                            delay: 0.3,
                                        })
                                    }
                                });

                            }

                    });

                });

                pagNav.forEach((el) => {
                    el.addEventListener('click', function (event) {
                        let active = document.getElementById('pagination').querySelector('.active')
                        let index = [].indexOf.call(triggerSlide, active);
                        //console.log(index)
                        if(el.dataset.type = 'next') {
                            index = index + 1;
                            if (index > pagButtonsLength) {
                                index = 0;
                            }
                        } else {
                            index = index - 1;
                            if (index < 0) {
                                index = pagButtonsLength;
                            }
                        }
                        pagButtons[index].click();
                        event.preventDefault();
                        if (clickSlider !== null) {
                            clickSlider = clearTimeout(clickSlider);
                            clickSlider = null;
                            clickSlider = setTimeout(function() {
                                document.getElementById("slider-next-arrow").click()
                            }, waitTime);
                        }
                    });
                });

                clickSlider = setTimeout(function() {
                    document.getElementById("slider-next-arrow").click()
                }, waitTime);

            };

            addEvents();

            $('#canvas-slider, .slider-inner, .slider .shadow').click(function(){
                //window.href = ($('#slide-video a').attr('href'));
            });
        }
    }
})(jQuery);


// WEBPACK FOOTER //
// ./resources/assets/js/partial/slider.js